module.exports = __webpack_public_path__ + "img/joshwoodroundtrans.54b7f053.png";